import React, { useState, useEffect } from "react";
import { Offcanvas, Button, Form, Alert } from "react-bootstrap";
import "./index.scss";

const DrawerForm = ({
  show,
  onClose,
  title,
  fields,
  onSubmit,
  initialData,
}) => {
  const initialValues = fields.reduce(
    (acc, field) => ({
      ...acc,
      [field.name]: field.type === "file" ? null : "",
    }),
    {}
  );

  const [formValues, setFormValues] = useState(initialValues);
  const [errors, setErrors] = useState({});

  // 👉 Charger les valeurs quand on ouvre pour "Edit"
  useEffect(() => {
    if (initialData) {
      setFormValues({
        ...initialValues,
        ...initialData, // pré-remplit avec les données existantes
      });
    } else {
      setFormValues(initialValues); // reset si création
    }
  }, [initialData, show]);

  const handleChange = (e) => {
    const { name, type, files, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: type === "file" ? files[0] : value,
    });

    if (errors[name]) {
      setErrors({ ...errors, [name]: "" });
    }
  };

  const validate = () => {
    const newErrors = {};
    fields.forEach((field) => {
      if (field.required) {
        if (field.type === "file" && !formValues[field.name]) {
          newErrors[field.name] = `${field.label} est requis`;
        } else if (!formValues[field.name]) {
          newErrors[field.name] = `${field.label} est requis`;
        }
      }

      if (field.type === "email" && formValues[field.name]) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formValues[field.name])) {
          newErrors[field.name] = "Email invalide";
        }
      }

      if (field.minLength && formValues[field.name]) {
        if (formValues[field.name].length < field.minLength) {
          newErrors[
            field.name
          ] = `${field.label} doit contenir au moins ${field.minLength} caractères`;
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      onSubmit(formValues); // le parent décide si add ou update
      onClose();
      setErrors({});
    }
  };

  return (
    <Offcanvas show={show} onHide={onClose} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form onSubmit={handleSubmit}>
          {fields.map((field) => (
            <Form.Group key={field.name} className="mb-3">
              <Form.Label>{field.label}</Form.Label>

              {field.type === "file" ? (
                <>
                  <Form.Control
                    type="file"
                    name={field.name}
                    onChange={handleChange}
                    accept="image/*"
                  />

                  {/* ✅ Fichier sélectionné */}
                  {formValues[field.name] instanceof File && (
                    <p className="mt-1">
                      Fichier sélectionné : {formValues[field.name].name}
                    </p>
                  )}

                  {/* ✅ Aperçu image existante si mode édition */}
                  {!(formValues[field.name] instanceof File) &&
                    formValues[field.name] && (
                      <div className="mt-2">
                        <img
                          src={formValues[field.name]} // URL venant du backend
                          alt="Aperçu"
                          style={{
                            width: "100px",
                            height: "100px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "1px solid #ddd",
                          }}
                        />
                      </div>
                    )}
                </>
              ) : (
                <Form.Control
                  type={field.type || "text"}
                  name={field.name}
                  value={formValues[field.name] || ""}
                  onChange={handleChange}
                  placeholder={field.placeholder || ""}
                />
              )}

              {errors[field.name] && (
                <Alert variant="danger" className="mt-1">
                  {errors[field.name]}
                </Alert>
              )}
            </Form.Group>
          ))}

          <Button type="submit" className="mt-2">
            {initialData ? "Mettre à jour" : "Créer"}
          </Button>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default DrawerForm;
